import { useMe } from '@/features/me/MeContext';

/**
 * Whether a user id addresses the caller themselves. The API treats `me` and
 * *any* of the caller's linked identities as the caller — an alias is still
 * the same person — so the whole `user_ids` list is the comparison, not just
 * the primary. This is what decides whether the private fields (gender,
 * birthdate, height, weight) are part of the record at all: they are the
 * person's own to see, absent from anyone else's view of them.
 */
export function useIsSelf(userId: string): boolean {
  const { me } = useMe();
  if (userId === 'me' || userId === '') return true;
  return (me.user_ids ?? []).includes(userId);
}
